import Button from '@/common/components/Button'
import Modal from '@/common/components/Modal'
import { ModalMessageSimple } from '@/common/components/ModalMessageSimple'
import { FormTransformers } from '@/common/utils/formTransformers'
import { MaintenanceForwardingEstablishmentChoiceEntryProposalData } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/types/maintenanceForwarding.type'
import { useMaintenanceEstablishmentChoiceManualEntryProposalsClientCancel } from '@/features/maintenanceWorkflow/pages/Show/hooks/forwardings/establishmentChoice/manualEntryProposals/useMaintenanceEstablishmentChoiceManualEntryProposalsClientCancel'
import { useQueryClient } from '@tanstack/react-query'
import { useState } from 'react'
import { useParams } from 'react-router-dom'

interface ManualEntryProposalsClientCancelProps {
  proposal: MaintenanceForwardingEstablishmentChoiceEntryProposalData
}

const ManualEntryProposalsClientCancel = ({ proposal }: ManualEntryProposalsClientCancelProps) => {
  const { id } = useParams()

  const queryClient = useQueryClient()

  const [isOpen, setIsOpen] = useState(false)

  const [messages, setMessages] = useState<string[] | boolean>(false)

  const { mutate: clientCancel, isPending: clientCancelIsPending } =
    useMaintenanceEstablishmentChoiceManualEntryProposalsClientCancel({
      proposalId: proposal.id,
      options: {
        onSuccess: () => {
          queryClient.invalidateQueries({ queryKey: ['maintenanceWorkflow', id] })
          queryClient.invalidateQueries({ queryKey: ['maintenanceWorkflowForwardings', id] })
          queryClient.invalidateQueries({ queryKey: ['maintenanceForwarding'] })

          setIsOpen(false)
        },
        onError: FormTransformers.errorsTransformer({ setMessages }),
      },
    })

  return (
    <>
      <Modal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        Trigger={
          <Button
            variant="outline-error"
            operationKlassToCheckPermission="Client::Maintenance::EstablishmentChoice::ManualEntryProposals::Cancel"
          >
            Cancelar proposta
          </Button>
        }
        title="Cancelar proposta"
        subtitle="Tem certeza que deseja cancelar esta proposta? O estabelecimento não estará mais apto para aceitar e você precisará selecionar um novo estabelecimento"
        titleClass="text-2xl"
        subtitleClassName="mt-1 text-white-400 text-md"
        useCancellableFooter
        showClose={false}
        onConfirm={() => clientCancel()}
        confirmButtonIsLoading={clientCancelIsPending}
      />

      <ModalMessageSimple messages={messages} setMessages={setMessages} isError />
    </>
  )
}

export default ManualEntryProposalsClientCancel
